import { common, config } from '@/common/service/apiList';
import ServiceExec from '@/common/utils/ServiceExec';
import ConstCode from '@/common/constants/ConstCode';
import axios from 'axios';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
const {
  getCommentTemplate,
  getEnum,
  getBibleList,
  insertValidCheck,
  getProductBusinessList,
  marketingFirstBuyCheck
} = common;
export default {
  async getCommentTemplate({ commit, state }) {
    const { data, status } = await ServiceExec.get(getCommentTemplate, {});
    if (status !== ServiceExec.status.OK) return false;

    commit('setTemplates', data ?? []);
  },

  async insertValidCheck({ commit }, type) {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(insertValidCheck(userNo, type));
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },
  async marketingFirstBuyCheck({ commit }, businessNo) {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(marketingFirstBuyCheck(userNo, businessNo));
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },
  async getProductBusinessList({ commit }, type) {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(getProductBusinessList(userNo, type));
    if (status !== ServiceExec.status.OK) return false;
    commit('setBusinessList', data);
    return true;
  },

  async getEnumData({ commit }) {
    const { data, status } = await ServiceExec.get(getEnum);
    if (status !== ServiceExec.status.OK) return false;
    commit('setEnum', data);
  },

  async getKakaoAdd({ commit }, reqData) {
    // 260618: 유령기업 카카오는 GPS 실위치 우선 (로그인 시 coordinate가 대표주소로 덮여도 항상 실제 위치 주변에서 검색).
    //          gpsCoordinate 없으면 coordinate fallback.
    const coordinate = store.getters['business/getGpsCoordinate'] || store.getters['business/getCoordinate'];
    const categoryList = store.getters['business/getCategoryList'];
    const kakaoCount = store.getters['business/kakaoPageableCount'];
    const kakaoSearchText = store.getters['business/kakaoSearchText'];

    // 260522: 카카오 keyword 정제 — 카테고리명을 카카오에 잘 잡히는 단일 keyword로 매핑.
    // 실측 기준 (jump-dev.site 좌표·반경 1km): firstTok("요식"/"의료"/"교육")은 카카오 매칭 0~2건, lastTok("카페"/"병원"/"학원")은 5~10건.
    // 명시 매핑이 없으면 lastTok fallback (대다수 케이스에서 더 높은 매칭률).
    const KAKAO_CATEGORY_KEYWORD = {
      '제조/유통/무역': '무역',
      '법률/세무': '세무사',
      'IT/개발': 'IT',
      '의료/병원': '병원',
      '교육/학원': '학원',
      '요식/카페': '카페',
      '웨딩/꽃/이벤트': '웨딩',
      '뷰티': '뷰티',
      '스포츠/헬스/건강': '헬스장',
      '반려동물': '반려동물',
      '의류/잡화/안경': '의류',
      '자동차/정비': '정비',
      '인테리어/디자인': '인테리어',
      '교회/종교단체': '교회',
      // 261103 공방/클래스(120) — 마지막 낱말 '클래스'로 폴백하면 학원·온라인 강의까지 섞여 공방이 묻힌다.
      '공방/클래스': '공방'
      // 260619 신규 카테고리(생활서비스/미디어·콘텐츠/광고·기획·마케팅/투자·자문·금융/
      //         문화·예술·공연/건설·건축/부동산/창업·프랜차이즈/취미·여행·캠핑)는
      //         명시 매핑 없이 lastTok 폴백 사용(예: 창업/프랜차이즈→프랜차이즈).
    };
    const rawQuery = reqData.searchText || categoryList[0]?.categoryName;
    let kakaoQuery = '';
    if (rawQuery) {
      kakaoQuery = KAKAO_CATEGORY_KEYWORD[rawQuery] || String(rawQuery).split('/').pop().trim();
    }
    if (!kakaoQuery) return false;

    if (kakaoSearchText === kakaoQuery && kakaoCount < reqData.page) {
      return false;
    }

    let instance = axios.create({
      baseURL: 'https://dapi.kakao.com'
    });

    instance.defaults.headers['Authorization'] = `KakaoAK ${ConstCode.CODE_ENV_LIST.KAKAO_REST_API_KEY}`;

    // 260618: 텍스트 가게명 검색(카테고리 매핑에 없는 자유 검색어)은 반경 20km로 확대 — 멀리 있어도 가게명으로 노출.
    //          카테고리 검색(매핑 hit)은 주변 발굴이라 1km 유지.
    const radius = (KAKAO_CATEGORY_KEYWORD[rawQuery] !== undefined) ? 1000 : 20000;
    const url = `https://dapi.kakao.com/v2/local/search/keyword.json?query=${encodeURIComponent(
      kakaoQuery
    )}&x=${encodeURIComponent(coordinate.longitude)}&y=${encodeURIComponent(
      coordinate.latitude
    )}&size=10&sort=distance&radius=${radius}&page=${reqData.page}`;

    store.commit('business/kakaoSearchText', kakaoQuery);

    try {
      const result = await instance.get(url);
      console.log('카카오 결과', result);

      const pageableCount = result.data?.meta?.pageable_count;
      const list = result.data?.documents;
      store.commit('business/kakaoPageableCount', pageableCount);
      if (pageableCount <= 0 || isEmpty(list)) {
        return;
      }
      if (reqData.isSearch) store.commit('business/businessSearchList', list || []);
      else store.commit('business/businessList', { isFlag: true, businessList: list || [] });

      return result;
    } catch (error) {
      console.error('API 요청 실패:', error);
    }
  },

  async getKakaoAddress({ commit }, params) {
    let instance = axios.create({
      baseURL: 'https://dapi.kakao.com'
    });

    // MEMO: Kakao API Authorization key
    instance.defaults.headers['Authorization'] = `KakaoAK ${ConstCode.CODE_ENV_LIST.KAKAO_REST_API_KEY}`;
    let url = `https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${params.longitude}&y=${params.latitude}`;

    const result = instance.get(url);

    return result;
  },

  async getBibleList({ commit }) {
    const { data, status } = await ServiceExec.get(getBibleList);
    if (status !== ServiceExec.status.OK) return false;
    commit('setBibleList', data);
  },

  /**
   * 네이버 지역검색 API 호출
   */
  async fetchNaverLocalData({ commit }, payload) {
    const { status, data } = await ServiceExec.get(common.fetchNaverLocalData(payload));
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },
  /**
   * 260527: 해외 주소 지오코딩(OSM) — 백엔드 경유. 응답은 네이버 지역검색과 동일 형식(items + mapx/mapy).
   */
  async fetchOverseasGeocode({ commit }, payload) {
    const { status, data } = await ServiceExec.get(common.fetchOverseasGeocode(payload));
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },
  async getHoliday({ commit }, payload) {
    const { status, data } = await ServiceExec.get(common.getHoliday());
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  // 260513 feature flag — App.vue mount 1회 + 라우터 가드에서 dispatch.
  // 기본은 캐시 hit 시 skip. force=true면 runtime toggle 반영 위해 강제 refetch
  // (운영에서 DB row 한 줄 update 후 기존 세션이 stale 안 되도록 라우터/엔트리 가드에서 force).
  // 실패 시 빈 객체(=전부 false 취급) 저장 — 안전한 fail-closed.
  async fetchFeatureFlags({ commit, state }, { force = false } = {}) {
    if (!force && state.featureFlagsLoaded) return state.featureFlags;
    try {
      const { data, status } = await ServiceExec.get(config.featureFlags);
      if (status !== ServiceExec.status.OK) {
        commit('setFeatureFlags', {});
        return {};
      }
      commit('setFeatureFlags', data || {});
      return data || {};
    } catch (_) {
      commit('setFeatureFlags', {});
      return {};
    }
  }
};
